import request from '@/utils/zsm-requets';
import Qs from 'qs';
// 阿里支付
const alipay = '/zsm/api/alipay/'
// 微信支付
const charge = '/zsm/api/charge/'

//--------------------------------------------

/* 阿里云支付*/

/**
 * 查询单笔订单
 * @param id 订单Id
*/
export function getPageOrderById(id) {
  return request({
    url: alipay + 'getPageOrderById',
    method: 'post',
    params: {id}
  })
};


/**
 * 订单列表
 * @param goodId：商品id
 * @param payFlag：支付状态
 * @param receiverMobile：买家手机号
 * 
 *
*/
export function alipayOrderList(info) {
  return request({
    url: alipay + 'orderList',
    method: 'post',
    params: info
  })
};


// 获取讲师端付费商品列表
export function getPageGoodByType() {
  return request({
    url: alipay + 'getPageGoodByType',
    method: 'get'
  })
};

/**
 * 讲师账单记录
 * @param {*} mobile 讲师账号
 * @param {*} id 订单号 
 * @returns 
 */
export function findPageOrderByMobile(params) {
  return request({
    url: alipay + 'findPageOrderByMobile',
    method: 'post',
    data: Qs.stringify(params)
  })
};




/** 
  * 网站支付宝
  * @param goodId 商品id
  * @param quantity 数量
  * @param receiverAddress 地址
  * @param receiverMobile 手机号
  * @param receiverName 收货人
  * @param returnUrl 回调地址
*/
export function prepayAlipay(info) {
  return request({
    url: alipay + 'prepay',
    method: 'post',
    params: info
  })
};

/**
 * 获取需要支付的单个产品
 * @param id 订单id
 * @returns {AxiosPromise}
 */
export function getAlipay(id) {
  return request({
    url: alipay + 'get',
    method: 'post',
    params: {
      id
    }
  })
};

/**
 * 获取需要支付的商品列表
 * @param params:{type:类型，id：id内容，title 标题}
 * @returns {AxiosPromise}
 */
export function listDataAlipay(params) {
  return request({
    url: alipay + 'listData',
    method: 'post',
    params
  })
};





// -------------------------------
/* 微信*/


/**
 * 微信web支付
 * @param goodId 商品Id
 * @param mobile 手机号
 */
export function wechatWebPay(params) {
  return request({
    url: charge + 'wechatWebPay',
    method: 'post',
    params
  })
};

